export default __webpack_public_path__ + "static/media/chatApp.d3983b97.gif";